import { LINCOLN_MONEYGUARD_2025_BANDS } from './lincolnPricingConfig';

/**
 * Returns the pricing multiplier for a premium, or undefined when the premium is above the
 * published band table.
 *
 * The two edges are handled deliberately differently. Above the last band, flat-clamping the
 * edge multiplier is what let benefits scale linearly to any premium while ROI stayed
 * constant (the A2 defect), so the premium is refused. Below the first band the flat clamp is
 * kept: extrapolation there shrinks benefits rather than inflating them, the premium is
 * already floored by investmentMin, and refusing would strand real quotes — Lincoln's table
 * starts at $50k while its stored premiums start at $10k.
 */
export function getMultiplierForPremium(premium: number): number | undefined {
  const bands = LINCOLN_MONEYGUARD_2025_BANDS;
  if (bands.length === 0) return undefined;

  const first = bands[0];
  const last = bands[bands.length - 1];

  if (premium > last.premium) return undefined;
  if (premium <= first.premium) return first.multiplier;
  if (premium === last.premium) return last.multiplier;

  for (let i = 0; i < bands.length - 1; i++) {
    if (premium >= bands[i].premium && premium < bands[i + 1].premium) {
      const t = (premium - bands[i].premium) / (bands[i + 1].premium - bands[i].premium);
      return bands[i].multiplier + t * (bands[i + 1].multiplier - bands[i].multiplier);
    }
  }

  return undefined;
}
